<template>    
    <div style="max-height: 100%; max-width: 100%">
        <canvas ref="chart"></canvas>    
    </div>
</template>

<script>
    import {Chart} from 'chart.js';
    export default{

        props:[
            'capital_1',
            'capital_2',
            'af',
            'name',
        ],
        
        mounted(){
            var ctx = this.$refs.chart.getContext('2d'), 
                gradient = ctx.createLinearGradient(0, 0, 0, 400);

            gradient.addColorStop(0, 'rgba(56, 103, 214,0.3)');
            gradient.addColorStop(0.5, 'rgba(56, 103, 214,0.1)');
            gradient.addColorStop(1, 'rgba(56, 103, 214, 0)');
            
            var labels = [];
            var prices_1 = [];
            var prices_2 = [];
            var prices_af = [];
            this.capital_1.forEach(value=>{
                labels.push(value.date);
                prices_1.push(value.value);
            });
            if (this.capital_2 && this.capital_2.length){
            this.capital_2.forEach(value=>{
                prices_2.push(value.value);
            })};
            if (this.af && this.af.length){
            this.af.forEach(value=>{
                prices_af.push(value.value);
            })};

            var tailletab = labels.length;
            console.log('lenght label', tailletab);
            
            if(tailletab > 365){
                for(var i = 0; i < tailletab; i++){
                    var modulo = i%365;
                    if(modulo != 0){
                        //labels[i]='';
                    }
                }
            }
            else if(tailletab > 30){
                for(var i = 0; i < tailletab; i++){
                    var modulo = i%30;
                    if(modulo != 0)
                        labels[i]='';
                }
            }
            else if(tailletab > 10){
                for(var i = 0; i < tailletab; i++){
                    var modulo = i%3;
                    if(modulo != 0)
                        labels[i]='';
                }
            }
            
            

            var graphTab = [];
            var graphTabIndex = 0;

            
            var capital1Graph = {
                label: 'DCA',
                backgroundColor: gradient,
                pointBackgroundColor: 'white',
                data: prices_1,
                fill: true,
                cubicInterpolationMode:'monotone',
                pointRadius: 2,
                borderColor:'rgba(255, 126, 12,0.7)',
                borderWidth: 1,
                yAxisID: 'A',
            };
            var capital2Graph = 
            {
                label: 'EDCA',
                backgroundColor: gradient,
                pointBackgroundColor: 'white',
                data: prices_2,
                fill: true,
                cubicInterpolationMode:'monotone',
                pointRadius: 2,
                borderColor:'rgba(154, 0, 226,0.7)',
                borderWidth: 1,
                yAxisID: 'A',
            };
            var capitalafGraph = 
            {
                label: String(this.name),
                backgroundColor: gradient,
                pointBackgroundColor: 'white',
                data: prices_af,
                fill: true,
                cubicInterpolationMode:'monotone',
                pointRadius: 2,
                borderColor:'rgba(51, 204, 51,0.7)',
                borderWidth: 1,
                yAxisID: 'B',
            };

            var tailleCapitalTab = prices_1.length;
            var capitalSomme = 0;
            for (var i=0; i < tailleCapitalTab; i++){
                capitalSomme = capitalSomme + prices_1[i];
            }
            if(capitalSomme != 0){
                graphTab[graphTabIndex] = capital1Graph;
                graphTabIndex++;
            }
            
            tailleCapitalTab = prices_2.length;
            capitalSomme = 0;
            for (var i=0; i < tailleCapitalTab; i++){
                capitalSomme = capitalSomme + prices_2[i];
            }

            if(capitalSomme != 0){
                graphTab[graphTabIndex] = capital2Graph;
                graphTabIndex++;
            }
            tailleCapitalTab = prices_af.length;
            capitalSomme = 0;
            for (var i=0; i < tailleCapitalTab; i++){
                capitalSomme = capitalSomme + prices_af[i];
            }

            if(capitalSomme != 0){
                graphTab[graphTabIndex] = capitalafGraph;
                graphTabIndex++;
            }




            var myChart = new Chart(ctx, {
                type: 'line',
                data: {    
                    labels: labels,   
                    datasets: graphTab,     
                },                
                options: {                    
                    maintainAspectRatio: false,    
                    responsive: true,
                    maintainAspectRatio: true,
                    animation: {
                        easing: 'easeInOutQuad',
                        duration: 2000
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                display: true,
                                drawOnChartArea: false,
                                color: 'rgba(56, 103, 214,0.2)',
                                lineWidth: 1,
                            },
                            ticks: {
                                fontFamily: "Poppins",
                                fontColor: 'rgb(56, 103, 214)',
                                fontStyle: 'bold',
                                fontSize: 10,
                                padding: 10,
                                },
                        }],
                        yAxes: [
                            {
                            id: 'A',
                            position: 'left',
                            scaleLabel: {
                                display: true,
                                labelString: "portefeuille client",
                                fontFamily: "Poppins",
                                fontSize: 10,
                                fontColor: 'rgb(56, 103, 214)',
                            },
                            gridLines: {
                                display: true,
                                drawOnChartArea: false,
                                color: 'rgba(56, 103, 214,0.2)',
                                lineWidth: 1,
                            },
                            ticks: {
                                userCallback: function(value, index, values) {
                                    value = value.toString();
                                    value = value.split(/(?=(?:...)*$)/);
                                    value = value.join(' ');
                                    return value + " " + "€";
                                },
                                    // Include a euro sign in the ticks
                                callback: function(value, index, values) {
                                    return value + " " + '€';
                                },
                                padding: 10,
                                fontFamily: "Poppins",
                                fontColor: 'rgb(56, 103, 214)',
                                suggestedMin: Math.min(...prices_1) - Math.min(...prices_1)*0.2,    // minimum will be 0, unless there is a lower value.
                                // OR //
                                beginAtZero: false,   // minimum value will be 0.
                                fontStyle: 'bold',
                                fontSize: 10,
                                autoSkip: true,
                                maxTicksLimit: 12
                            }
                        },
                        {
                            id: 'B',
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: "valeur du fond",
                                fontFamily: "Poppins",
                                fontSize: 10,
                                fontColor: 'rgb(56, 103, 214)',
                            },
                            gridLines: {
                                display: true,
                                drawOnChartArea: false,
                                color: 'rgba(56, 103, 214,0.2)',
                                lineWidth: 1,
                            },
                            ticks: {
                                userCallback: function(value, index, values) {
                                    value = value.toString();
                                    value = value.split(/(?=(?:...)*$)/);
                                    value = value.join(' ');
                                    return value + " " + "€";
                                },
                                    // Include a euro sign in the ticks
                                callback: function(value, index, values) {
                                    return value + " " + '€';
                                },
                                padding: 10,
                                fontFamily: "Poppins",
                                fontColor: 'rgb(56, 103, 214)',
                                suggestedMin: Math.min(...prices_1) - Math.min(...prices_1)*0.2,    // minimum will be 0, unless there is a lower value.
                                // OR //
                                beginAtZero: false,   // minimum value will be 0.
                                fontStyle: 'bold',
                                fontSize: 10,
                                autoSkip: true,
                                maxTicksLimit: 12
                            },
                        }],
                    },
                    elements: {
                        line: {
                            tension: 0.4
                        }
                    },
                    legend: {
                        display: true,
                        fontFamily: 'Poppins'
                    },
                    point: {
                        backgroundColor: 'white'
                    },
                    tooltips: {
                        titleFontFamily: 'Poppins',
                        titleFontStyle: 'normal',
                        titleMarginBottom: 10,
                        titleAlign: 'center',
                        backgroundColor: 'rgb(56, 103, 214)',
                        titleFontColor: '#FFF',
                        caretSize: 2,
                        cornerRadius: 4,
                        xPadding: 15,
                        yPadding: 15,
                        bodyAlign: 'center',
                        bodyFontFamily: 'Poppins',
                        bodyFontSize: 12,
                        bodyFontColor: 'white',
                        bodySpacing: 4,
                        custom: function(tooltip) {
                            if (!tooltip) return;
                            // disable displaying the color box;
                            tooltip.displayColors = false;
                        },
                        callbacks: {

                            label: function(tooltipItem, data) {
                                return "Solde" + " : " + tooltipItem.yLabel.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + " " + "€";
                            },
                        }
                    }               
                }
            });
        }
    }
</script>